import { createAction, handleActions } from 'redux-actions';
import Agent from '../../api/Agent';
import formatDate from '../../services/formatDate';
import { setUser, handleError, setSupervisorOrgStatus } from '../user';

import { getOrganizationShiftTimes, setShiftOrganizationID } from './shift';
import { isFeatureActive } from '../../redux/features';
import testFeatures from '../../constants/testFeatures';

export const setsupervisorshiftlist = createAction('SET_SUPERVISOR_SHIFT_LIST');
export const setorganizations = createAction('SET_ORGANIZATIONS');
export const setlocations = createAction('SET_LOCATIONS');
export const setDepartments = createAction('SET_DEPARTMENTS');
export const setRoles = createAction('SET_ROLES');
export const setAcceptedApplicantDetail = createAction('SET_ACCEPTED_APPLICANT_DETAIL');

export const clearlocations = createAction('CLEAR_LOCATIONS');
export const cleardepartments = createAction('CLEAR_DEPARTMENTS');
export const clearstatus = createAction('CLEAR_STATUS');
export const clearsupervisors = createAction('CLEAR_SUPERVISORS');
export const clearStartDate = createAction('CLEAR_STARTDATE');
export const clearEndDate = createAction('CLEAR_ENDDATE');
export const clearRoles = createAction('CLEAR_ROLES');

export const setnotifications = createAction('SET_NOTIFICATIONS');
export const setnoticecount = createAction('SET_NOTICECOUNT');
export const setcountdisplay = createAction('SETCOUNTDISPLAY');
export const setsupervisor = createAction('SET_SUPERVISOR');
export const setuserinfo = createAction('SET_USERINFO');

export const changeStatus = createAction('CHANGE_STATUS');
export const changeLocation = createAction('CHANGE_LOCATION');
export const changeDepartment = createAction('CHANGE_DEPARTMENT');
export const changeSupervisor = createAction('CHANGE_SUPERVISOR');
export const changeRole = createAction('CHANGE_ROLE');

export const setStartDate = createAction('SET_START_DATE');
export const setEndDate = createAction('SET_END_DATE');
export const setShiftList = createAction('SET_SHIFT_LIST');
export const setPageNumber = createAction('SET_PAGE_NUMBER');

export const clearorgList = createAction('CLEAR_ORGLIST');
export const cleardeptList = createAction('CLEAR_DEPTLIST');
export const clearlocList = createAction('CLEAR_LOCLIST');
export const clearSupervisorList = createAction('CLEAR_SUPERVISORLIST');
export const setNoticeStatus = createAction('SET_NOTICESSTATUS');

export const clearSupervisorShiftList = createAction('CLEAR_SUPERVISOR_SHIFT_LIST');
export const clearNotification = createAction('CLEAR_NOTIFICATION');
export const clearUserInfo = createAction('CLEAR_USERINFO');

export const setCriticalAlerts = createAction('SET_CRITICAL_ALERTS');
export const clearCriticalAlerts = createAction('CLEAR_CRITICAL_ALERTS');

export const setGeneralAlerts = createAction('SET_GENERAL_ALERTS');
export const clearGeneralAlerts = createAction('CLEAR_GENERAL_ALERTS');
export const setAlertMessage = createAction('SET_ALERT_MESSAGE');
export const setAlertExpiry = createAction('SET_ALERT_EXPIRY');
export const setAlertType = createAction('SET_ALERT_TYPE');
export const getOrgId = createAction('SET_ORG_ID');

export const setSort = createAction('SET_SORT');
export const setSortOrder = createAction('SET_SORT_ORDER');
export const resetSuperShiftList = createAction('RESET_SUPER_SHIFT_LIST');

export const setIsFetchingSupervisorShiftList = createAction('SET_IS_FETCHING_SUPERVISOR_SHIFT_LIST');

const initialState = {
	acceptedUserDetails: [],
	alert_expiry: 0,
	alert_message: '',
	alert_type: 0,
	criticalAlertList: [],
	departments: [],
	dept: '',
	display: 'none',
	distance: '',
	from_date: '',
	generalAlertList: [],
	info: {},
	isFetchingShiftList: false,
	loc: '',
	locations: [],
	noticeCount: {},
	notifications: [],
	notificationStatus: 'Loading...',
	org_id: 0,
	organizations: {},
	page_no: 1,
	role: '',
	roles: [],
	shiftList: [],
	sort: '',
	sortorder: '',
	status: '',
	supershiflist: {},
	supervisor: '',
	supervisorsList: [],
	to_date: '',
	zip_code: ''
};

export default handleActions(
	{
		CHANGE_DEPARTMENT: (state, action) => ({ ...state, dept: action.payload }),
		CHANGE_LOCATION: (state, action) => ({ ...state, loc: action.payload }),
		CHANGE_ROLE: (state, action) => ({ ...state, role: action.payload }),
		CHANGE_STATUS: (state, action) => ({ ...state, status: action.payload }),
		CHANGE_SUPERVISOR: (state, action) => ({ ...state, supervisor: action.payload }),
		CLEAR_CRITICAL_ALERTS: (state) => ({ ...state, criticalAlertList: initialState.criticalAlertList }),
		CLEAR_DEPARTMENTS: (state) => ({ ...state, dept: initialState.dept }),
		CLEAR_DEPTLIST: (state) => ({ ...state, departments: initialState.departments }),
		CLEAR_ENDDATE: (state) => ({ ...state, to_date: initialState.to_date }),
		CLEAR_GENERAL_ALERTS: (state) => ({ ...state, generalAlertList: initialState.generalAlertList }),
		CLEAR_LOCATIONS: (state) => ({ ...state, loc: initialState.loc }),
		CLEAR_NOTIFICATION: (state) => ({ ...state, notifications: initialState.notifications }),
		CLEAR_ORGLIST: (state) => ({ ...state, organizations: initialState.organizations }),
		CLEAR_ROLES: (state) => ({ ...state, role: initialState.role }),
		CLEAR_STARTDATE: (state) => ({ ...state, from_date: initialState.from_date }),
		CLEAR_STATUS: (state) => ({ ...state, status: initialState.status }),
		CLEAR_SUPERVISOR_SHIFT_LIST: (state) => ({ ...state, supershiflist: initialState.supershiflist }),
		// CLEAR_LOCLIST: (state) => ({...state, locations: initialState.locations}),
		CLEAR_SUPERVISORLIST: (state) => ({ ...state, supervisorsList: initialState.supervisorsList }),
		CLEAR_SUPERVISORS: (state) => ({ ...state, supervisor: initialState.supervisor }),
		CLEAR_USERINFO: (state) => ({ ...state, info: initialState.info }),
		RESET_SUPER_SHIFT_LIST: () => initialState,
		SET_ACCEPTED_APPLICANT_DETAIL: (state, action) => ({ ...state, acceptedUserDetails: action.payload }),
		SET_ALERT_EXPIRY: (state, action) => ({ ...state, alert_expiry: action.payload }),
		SET_ALERT_MESSAGE: (state, action) => ({ ...state, alert_message: action.payload }),
		SET_ALERT_TYPE: (state, action) => ({ ...state, alert_type: action.payload }),
		SET_CRITICAL_ALERTS: (state, action) => ({ ...state, criticalAlertList: action.payload }),
		SET_DEPARTMENTS: (state, action) => ({ ...state, departments: action.payload }),
		SET_END_DATE: (state, action) => ({ ...state, to_date: action.payload }),
		SET_GENERAL_ALERTS: (state, action) => ({ ...state, generalAlertList: action.payload }),
		SET_IS_FETCHING_SUPERVISOR_SHIFT_LIST: (state, action) => ({ ...state, isFetchingShiftList: action.payload }),
		SET_LOCATIONS: (state, action) => ({ ...state, locations: action.payload }),
		SET_NOTICECOUNT: (state, action) => ({ ...state, noticeCount: action.payload }),
		SET_NOTICESSTATUS: (state, action) => ({ ...state, notificationStatus: action.payload }),
		SET_NOTIFICATIONS: (state, action) => ({ ...state, notifications: action.payload }),
		SET_ORG_ID: (state, action) => ({ ...state, org_id: action.payload }),
		SET_ORGANIZATIONS: (state, action) => ({ ...state, organizations: action.payload }),
		SET_PAGE_NUMBER: (state, action) => ({ ...state, page_no: action.payload }),
		SET_ROLES: (state, action) => ({ ...state, roles: action.payload }),
		SET_SHIFT_LIST: (state, action) => ({ ...state, shiftList: action.payload }),
		SET_SORT: (state, action) => ({ ...state, sort: action.payload }),
		SET_SORT_ORDER: (state, action) => ({ ...state, sortorder: action.payload }),
		SET_START_DATE: (state, action) => ({ ...state, from_date: action.payload }),
		SET_SUPERVISOR: (state, action) => ({ ...state, supervisorsList: action.payload }),
		SET_SUPERVISOR_SHIFT_LIST: (state, action) => ({ ...state, supershiflist: action.payload }),
		SET_USERINFO: (state, action) => ({ ...state, info: action.payload }),
		SETCOUNTDISPLAY: (state, action) => ({ ...state, display: action.payload })
	},
	initialState
);

export const clearValues = () => {
	return function (dispatch) {
		dispatch(setPageNumber(1));
		dispatch(clearlocations());
		dispatch(cleardepartments());
		dispatch(clearstatus());
		dispatch(clearsupervisors());
		dispatch(clearStartDate());
		dispatch(clearEndDate());
		dispatch(clearRoles());
	};
};
export const pageNumber = (pageNo) => {
	return function (dispatch) {
		dispatch(setIsFetchingSupervisorShiftList(true));
		dispatch(setPageNumber(pageNo));
		dispatch(supervisorShiftList());
	};
};

export const supervisorShiftList = () => {
	return function (dispatch, getState) {
		let formatStartDate, formatEndDate;
		const { page_no, organizations, status, role, loc, dept, supervisor, from_date, to_date, sort, sortorder } =
			getState().supervisorshiftlist;
		const { globalFeatures } = getState().features;

		//Format start and end date to update list.
		const { dateFilterFormat } = formatDate;
		if (from_date != '') {
			formatStartDate = dateFilterFormat(from_date);
		} else {
			formatStartDate = from_date;
		}
		if (to_date != '') {
			formatEndDate = dateFilterFormat(to_date);
		} else {
			formatEndDate = to_date;
		}
		dispatch(setIsFetchingSupervisorShiftList(true));
		dispatch(clearSupervisorShiftList());

		if (!isFeatureActive(testFeatures.SUPERVISOR_SHIFT_LIST_API_V2, globalFeatures)) {
			Agent.supervisorDashboard(
				page_no,
				organizations.organization_id,
				status,
				role,
				loc,
				dept,
				supervisor,
				formatStartDate,
				formatEndDate,
				sort,
				sortorder
			).then((response) => {
				dispatch(setIsFetchingSupervisorShiftList(false));
				if (response.ok) {
					dispatch(setsupervisorshiftlist(response.data));
				} else {
					dispatch(handleError(response));
				}
			});
		} else {
			Agent.supervisorDashboardV2(
				page_no,
				organizations.organization_id,
				status,
				role,
				loc,
				dept,
				supervisor,
				formatStartDate,
				formatEndDate,
				sort,
				sortorder
			).then((response) => {
				dispatch(setIsFetchingSupervisorShiftList(false));
				if (response.ok) {
					dispatch(setsupervisorshiftlist(response.data));
				} else {
					dispatch(handleError(response));
				}
			});
		}
	};
};

export const organization = (id) => {
	return function (dispatch) {
		Agent.organizationById(id).then((response) => {
			if (response.ok) {
				dispatch(setorganizations(response.data));
				dispatch(supervisorShiftList());
				dispatch(setlocations(response.data.locations));
			} else {
				dispatch(handleError(response));
			}
		});
	};
};

export const notification = () => {
	return function (dispatch) {
		Agent.notices().then((response) => {
			if (response.ok) {
				dispatch(setnotifications(response.data));
				dispatch(count());
				if (response.data.length === 0) {
					dispatch(setNoticeStatus('You have no notifications.'));
				}
			} else {
				dispatch(handleError(response));
			}
		});
	};
};

export const count = () => {
	return function (dispatch) {
		Agent.noticeCount().then((response) => {
			if (response.ok) {
				dispatch(setnoticecount(response.data));
				if (response.data.notice_count > 0) {
					dispatch(setcountdisplay('block'));
				} else {
					dispatch(setcountdisplay('none'));
				}
			} else {
				dispatch(handleError(response));
			}
		});
	};
};

export const removeNotices = (id) => {
	return function (dispatch) {
		Agent.deleteNotices(id).then((response) => {
			if (response.ok) {
				dispatch(notification());
			} else {
				dispatch(handleError(response));
			}
		});
	};
};

export const supervisor = (id, locid) => {
	return function (dispatch) {
		Agent.supervisors(id, locid).then((response) => {
			if (response.ok) {
				dispatch(setsupervisor(response.data));
			} else {
				dispatch(handleError(response));
			}
		});
	};
};

export const userInfo = () => {
	return function (dispatch) {
		Agent.userinfo().then((response) => {
			if (response.ok) {
				dispatch(setUser(response.data));
				dispatch(setuserinfo(response.data));
				dispatch(getOrganizationShiftTimes(response.data.user_orgs[0].organization_id));
				dispatch(setShiftOrganizationID(response.data.user_orgs[0].organization_id));
				dispatch(organization(response.data.user_orgs[0].organization_id));
				dispatch(supervisor(response.data.user_orgs[0].organization_id, 'NA'));
				dispatch(getCriticalalerts(response.data.user_orgs[0].organization_id, 1));
				dispatch(getGeneralalerts(response.data.user_orgs[0].organization_id, 0));
				dispatch(getOrgId(response.data.user_orgs[0].organization_id));
				dispatch(setSupervisorOrgStatus(response.data.user_orgs[0].organization_status));
			} else {
				dispatch(handleError(response));
			}
		});
	};
};

export const roles = () => {
	return function (dispatch) {
		Agent.roleOptions().then((response) => {
			if (response.ok) {
				dispatch(setRoles(response.data));
			} else {
				dispatch(handleError(response));
			}
		});
	};
};

export const acceptedApplicantDetails = (id) => {
	return function (dispatch) {
		Agent.getAcceptedShiftApplicant(id).then((response) => {
			if (response.ok) {
				dispatch(setAcceptedApplicantDetail(response.data));
			} else {
				dispatch(handleError(response));
			}
		});
	};
};

export const getCriticalalerts = (id, priority) => {
	return function (dispatch) {
		Agent.getAlert(id, priority).then((response) => {
			if (response.ok) {
				dispatch(setCriticalAlerts(response.data));
			} else {
				dispatch(handleError(response));
			}
		});
	};
};

export const getGeneralalerts = (id, priority) => {
	return function (dispatch) {
		Agent.getAlert(id, priority).then((response) => {
			if (response.ok) {
				dispatch(setGeneralAlerts(response.data));
			} else {
				dispatch(handleError(response));
			}
		});
	};
};

export const createAlert = () => {
	return function (dispatch, getState) {
		const { organizations, loc, dept, alert_message, alert_expiry, alert_type } = getState().supervisorshiftlist;
		let loc_int = parseInt(loc);
		let dept_int = parseInt(dept);
		let expiration_date = parseInt(alert_expiry);

		Agent.createAlert(
			organizations.organization_id,
			loc_int,
			dept_int,
			alert_type,
			alert_message,
			expiration_date
		).then((response) => {
			dispatch(changeLocation(''));
			dispatch(changeDepartment(''));
			if (response.ok) {
				if (alert_type == 0) {
					dispatch(getGeneralalerts(organizations.organization_id, alert_type));
				} else if (alert_type == 1) {
					dispatch(getCriticalalerts(organizations.organization_id, alert_type));
				}
			} else {
				dispatch(handleError(response));
			}
		});
	};
};
